// check if string has white spaces
export const whiteSpacesValidation = (str: string): boolean => {
  return !str.replace(/\s/g, '') ? true : false;
};

// check if string starts or ends with whitespaces
export const startEndWithWhiteSpacesValidation = (str: string): boolean => {
  return str.match(/^\s.+|.+\s{2,}$/g) ? true : false;
};
